import axios from 'axios';
import i18n from 'i18next';

import { AuthService, localStorageAccessTokenKey } from '../services/auth';
import { store } from '../redux/store';
import { setUserInfo, setMonthlyOverview } from '../redux/actions';
import { showSnackbar } from '../shared/services/snackbar';
import { Routes } from './routes';

const instantiateRequestInterceptor = () => {
  axios.interceptors.request.use((config) => {
    const token = localStorage.getItem(localStorageAccessTokenKey);

    if (token && token !== 'null' && AuthService.isExpired()) {
      AuthService.deleteToken();
      store.dispatch(setUserInfo({ id: null }));
      store.dispatch(setMonthlyOverview(null));
      showSnackbar(i18n.t('session-expired'), { variant: 'warning' });

      if (window.location.pathname !== Routes.signIn) {
        window.history.pushState(null, '', Routes.signIn);
        window.dispatchEvent(new PopStateEvent('popstate'));
      }

      return Promise.reject(new Error('Session expired'));
    }

    if (token && token !== 'null') {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  });
};

export default instantiateRequestInterceptor;
